import MUIIconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { IconButtonProps } from './IconButton.types';

export const IconButton = ({ color = 'inherit', size = 'medium', icon, label, onClick }: IconButtonProps) => {
	return (
		<Tooltip title={label} arrow>
			<MUIIconButton
				color={color}
				aria-label={label.toLowerCase()}
				size={size}
				onClick={onClick}
				sx={{
					'&:hover': {
						color: `${color}.main`
					}
				}}
			>
				{icon}
			</MUIIconButton>
		</Tooltip>
	);
};
